import { Card, Space, Typography } from 'antd';
import { useFormContext } from 'react-hook-form';
import { BaseQuestinnaireProps } from './customerQuestionnaire';

const { Title, Text } = Typography;

const copyableConfig = {
  tooltips: false,
};

export default function CustomerCard({ prefix }: BaseQuestinnaireProps) {
  const { getValues } = useFormContext();

  return (
    <div>
      <Title level={4}>Основная информация</Title>
      <Card title={getValues(`${prefix}.displayName`)}>
        <Space size={16}>
          <Space size={4}>
            <Text type="secondary">
              ИНН:
            </Text>
            <Text copyable={copyableConfig}>{getValues(`${prefix}.inn`)}</Text>
          </Space>

          <Space size={4}>
            <Text type="secondary">
              {getValues(`${prefix}.kpp`) ? "ОГРН" : "ОГРНИП"}:
            </Text>
            <Text copyable={copyableConfig}>{getValues(`${prefix}.ogrn`)}</Text>
          </Space>
          {getValues(`${prefix}.kpp`) && (
            <Space size={4}>
              <Text type="secondary">
                КПП:
              </Text>
              <Text copyable={copyableConfig}>{getValues(`${prefix}.kpp`)}</Text>
            </Space>
          )}
        </Space>
      </Card>
    </div>
  );
}
